let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5m0t0")).then(() => parcelRequire('eY10M'));